module.exports = __webpack_public_path__ + "assets/img/es-5007ed4d.png";